import React from "react";
import { View, Dimensions, TouchableOpacity, Platform } from "react-native";
import LottieView from "lottie-react-native";
// import { ENV_TYPE } from "@env";

const { width } = Dimensions.get("window");

class BookAnimation extends React.Component {
  state = {
    loop: true,
  };

  componentDidMount() {
    if (this.props.playing) {
      this?.animation?.play();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.playing && this.props.playing) {
      this?.animation?.play();
    } else if (!this.props.playing) {
    }
  }

  render() {
    return (
      <View onPress={this.triggerAgain} style={styles.mainView}>
        <LottieView
          ref={animation => {
            this.animation = animation;
          }}
          loop={Platform.OS === "ios" ? true : this.props.playing}
          style={{ height: this.props.size, width: this.props.size }}
          source={require("../../../assets/lottie/acrobatics.json")}
        />
      </View>
    );
  }
}

const styles = {
  lottieWrapper: {
    alignItems: "center",
    justifyContent: "center",
  },
  mainView: {
    zIndex: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  animationStyle: {
    height: width / 2,
    width: width / 2,
  },
};

BookAnimation.defaultProps = {
  size: width / 2,
};

export default BookAnimation;
